import * as defaultImport from "@splunk/react-icons/enterprise/GaugeFiller";
export * from "@splunk/react-icons/enterprise/GaugeFiller";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
